<template>
  <div v-if="!loaded"></div>
  <div v-else>
    <div v-if="!isSoldOut" class="main-container">
      <div class="bread" v-if="!!$route.query.recommend">
        <router-link :to="{ name: 'Index' }">首页</router-link>
        <span class="slash">/</span>
        <router-link
          :to="{
            name: 'IndexRecommendCourse',
            query: {
              title: $route.query.title,
              recommend: $route.query.recommend,
            },
          }"
        >
          {{ $route.query.title }}
        </router-link>
        <span class="slash">/</span>
        <span class="current">{{ course.title }}</span>
      </div>
      <div class="bread" v-else>
        <router-link :to="{ path: nav.url }">{{ nav.name }}</router-link>
        <span class="slash">/</span>
        <span class="current">{{ course.title }}</span>
      </div>
      <RichCourseShow
        :course="course"
        :couponList="couponList"
        :teachers="teachers"
        :courses="courses"
        :comments="comments"
        :has_buy="has_buy"
        :recommendCourses="recommendCourses"
        :discountList="discountList"
        :discountCourseList="discountCourseList"
        @shareClick="shareCourse"
        @goToStudy="goToStudy"
        @buy="buy"
        @getCoupon="getCoupon"
        @commentDelete="onCommentDelete"
        @changeTag="onChangeTag"
        @changeDiscount="onChangeDiscount"
        @discountBuy="discountBuy"
      ></RichCourseShow>
      <el-dialog title="分享" :visible.sync="showShareModal" width="400px">
        <vue-qr :text="shareUrl" :size="200" class="center"></vue-qr>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showShareModal = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <CourseSoldOut v-else></CourseSoldOut>
  </div>
</template>
<script>
import RichCourseShow from "../../components/rich/CourseShow.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";
import VueQr from "vue-qr";

export default {
  name: "CourseShow",
  components: {
    VueQr,
    RichCourseShow,
    CourseSoldOut,
  },
  data() {
    return {
      share: require("@/assets/images/course/share@2x.png"),
      id: this.$route.params.id,
      course: {},
      has_buy: false,
      has_join_spell: false,
      couponList: [],
      teachers: [],
      currentTime: "",
      tab: 0,
      courses: [],
      comments: [],
      recommendCourses: [],
      scrollTop: 0,
      rightFixed: 0,
      rightTop: 206,
      rightFixedPosition: 0,
      rightFixedBottom: 0,
      rightHeight: 0,
      leftFixed: 0,
      leftTop: 0,
      leftFixedPosition: 0,
      leftFixedBottom: 0,
      leftHeight: 0,
      footbarTop: 0,
      showShareModal: false,
      $right: null,
      $footer: null,
      $left: null,
      $courseInfo: null,
      isSoldOut: false,
      loaded: false,
      discountList: [],
      discountCourseList: [],
    };
  },
  computed: {
    shareUrl() {
      return (
        this.$store.state.commonSetting.h5_address +
        "/course-detail?id=" +
        this.id +
        "&courseType=" +
        this.course.course_type +
        "&share_source=pc"
      );
    },
    navigates() {
      return this.$store.state.navigates;
    },
    nav() {
      let nav = this.navigates.filter(n => n.id == this.$route.query.nav)[0];
      if (nav && nav.url != "/index") {
        nav = { ...nav };
        let url = nav.url;
        if (url.indexOf("?") < 0) {
          url += "?";
        } else {
          url += "&";
        }
        url += "nav=" + nav.id;
        nav.url = url;
        return nav;
      }
      return { name: "选课中心", url: "/course" };
    },
  },
  async created() {
    await this.getData();
  },
  watch: {
    async $route() {
      this.id = this.$route.params.id;
      await this.getData();
    },
  },
  methods: {
    async getData() {
      this.tab = this.$route.query.tab || 0;
      this.currentTime = new Date().format("yyyy-MM-dd hh:mm:ss");
      await this.getCourse();
      await this.getCourses();
      await this.getComment();
      await this.getDiscountList();
      this.loaded = true;
    },
    async getCourse() {
      let data = await this.$http.get(
        "/api/app/courseInfo/basis_id=" + this.id,
        {},
        {
          onError: data => {
            if (data.msg == "课程不存在!") {
              this.$error(data.msg);
              this.$router.push({ name: "Course" });
            }
          },
        },
      );
      data.info.is_sold_out =
        data.info.store_num > 0 &&
        data.info.store_num < 999999 &&
        data.info.stock == 0;
      if (
        data.info.status == 2 &&
        (data.info.is_buy == 0 || data.info.is_go_to_study == 0)
      ) {
        this.isSoldOut = true;
      }
      data.info.enter_end_date_str = new Date(
        data.info.enter_end_date * 1000,
      ).format("yyyy/MM/dd hh:mm");
      if (data.info.vip_user_end) {
        data.info.vip_user_end_str = new Date(
          data.info.vip_user_end * 1000,
        ).format("yyyy-MM-dd");
      }
      this.course = data.info;
      this.course.shop_id = this.course.id;
      this.course.shop_type = this.course.course_type;
      this.teachers = data.teachers;
      this.couponList = data.couponList;
      let recommendCourse=await this.$http.get(`/api/app/recommend/info/1,2`);
      this.recommendCourses = recommendCourse[0]&&recommendCourse[0].course;
      this.recommendCourses&&this.recommendCourses.forEach(i=>{
        i.marketing_language="";
      });
      if (data.info.course_type == 4) {
        this.tab = 3;
      }

      if (data.info.spell_id) {
        let group = await this.$http.get(
          "/api/app/spellGroupInfo/" + this.id + "/course",
        );
        if (
          (group.is_join_spell && group.group_status == 1) ||
          (!group.is_join_spell && this.course.valid_end_time >= 0)
        ) {
          this.has_buy = true;
        }
        this.has_join_spell = !!group.is_join_spell;
      } else {
        this.has_buy = this.course.valid_end_time >= 0;
      }
    },
    async getCourses() {
      if (this.course.course_type != 9) {
        return;
      }
      let courses = await this.$http.post("/api/app/sysCourseList", {
        id: this.id,
      });
      if (courses.length > 3) {
        let diff = 3 - (courses.length % 3);
        for (let i = 0; i < diff; i++) {
          courses.push({ ...courses[i] });
        }
      }
      this.courses = courses;
    },
    async collect() {
      this.course.collect_id = await this.$http.post(
        "/api/app/collect",
        {
          course_basis_id: this.id,
          type: 1,
        },
        true,
      );
      this.course.is_collect = 1;
      await this.$success("收藏成功");
    },
    async cancelCollect() {
      await this.$http.put(
        "/api/app/collect/cancel/" + this.course.collect_id + "/1",
      );
      this.course.is_collect = 0;
      await this.$success("取消收藏成功");
    },
    changeTab(tab) {
      this.tab = tab;
    },
    async buy() {
      if (
        this.has_join_spell &&
        this.$services.CourseService.checkBuyValid(this.course)
      ) {
        this.$info("您已经参与拼团了，不能单独购买。");
        return;
      }
      if (this.course.course_type == 7) {
        let nowTs = new Date().getTime() / 1000;
        if (nowTs > this.course.enter_end_date) {
          this.$info("你来晚了哦,已过报名截止时间~");
          return;
        }
      }
      if (this.course.is_sold_out && !this.has_buy) {
        this.$alert("你来晚了哦,名额已经没有了", "提示");
        return;
      }
      let obj = {
        shop_id: this.course.shop_id,
        shop_type: this.course.shop_type,
        coupon_id: 0,
        product_number: 1,
      };
      this.$router.push({
        name: "OrderConfirm",
        params: {
          id: this.id,
        },
        query: {
          type: this.course.course_type,
          vip: this.course.is_vip_user && this.course.is_vip_course ? 1 : 0,
          order_type: 1,
          shop_infos: JSON.stringify([obj]),
        },
      });
    },
    async getCoupon(id) {
      let data = await this.$http.get("/api/app/userGetCoupon/" + id);
      this.couponList.filter(c => c.id == id)[0].is_can_get =
        data.is_continue_get == 1 ? 1 : 0;
      this.$message({
        message: "领取成功",
        type: "success",
      });
    },
    async getComment() {
      let data = await this.$http.post("/api/app/courseComment", {
        id: this.id,
      });
      this.comments = data.list;
    },
    async goToPlay() {
      this.$livePlay(this.id, this.course.course_type, {
        id: 0,
        title: this.course.title,
      });
    },
    async goToStudy() {
      let id;
      let type;
      if (this.course.course_type == 9 && this.courses.length > 0) {
        id = this.courses[0].id;
      } else {
        id = this.$route.params.id;
        type = this.course.course_type;
      }
      this.$router.push({
        name: "MemberStudy",
        query: {
          id: id,
          type: type,
        },
      });
    },
    async shareCourse() {
      this.showShareModal = true;
    },
    async onCommentDelete() {
      await this.getComment();
    },
    async getDiscountList() {
      let data = await this.$http.get("/api/app/discount/course/discounts/", {
        course_basis_id: this.id,
      });
      this.discountList = data;
      if (data.length > 0) {
        // await this.getDiscountCourseList(
        //   data[0].id,
        //   data[0].display_tag == 1 ? data[0].tags[0].id : ""
        // );
        await this.getDiscountCourseList(data[0].id, "");
      }
    },
    async getDiscountCourseList(discountId, tagId) {
      let data = await this.$http.get(
        "/api/app/discount/course/discounts/" + discountId,
        {
          tag_id: tagId,
          course_basis_id: this.id,
        },
      );
      this.discountCourseList = data;
    },
    async onChangeTag(val) {
      this.getDiscountCourseList(val.discount_id, val.id);
    },
    async onChangeDiscount(val) {
      await this.getDiscountCourseList(val.id, "");
    },
    async discountBuy(val) {
      if (
        val.currentDiscount.rules.count &&
        val.currentDiscount.rules.count.length
      ) {
        val.currentDiscount.rules.count.sort((a, b) => {
          return a.condition - b.condition;
        });
        if (
          val.currentDiscount.rules.count[0].condition >
          val.checkedCourse.length
        ) {
          this.$info(
            "报名满" +
              val.currentDiscount.rules.count[0].condition +
              "门课程才能参与活动~",
          );
          return;
        }
      } else {
        if (val.checkedCourse.length < 2) {
          this.$info("报名满2门才能参与活动~");
          return;
        }
        if (
          val.currentDiscount.rules.price &&
          val.currentDiscount.rules.price.length
        ) {
          val.currentDiscount.rules.price.sort((a, b) => {
            return a.condition - b.condition;
          });
          if (val.currentDiscount.rules.price[0].condition > val.totalPrice) {
            this.$info(
              "报名满" +
                val.currentDiscount.rules.price[0].condition / 100 +
                "元课程才能参与活动~",
            );
            return;
          }
        }
      }
      this.$router.push({
        name: "OrderConfirm",
        params: {
          id: this.id,
        },
        query: {
          type: this.course.course_type,
          vip: this.course.is_vip_user && this.course.is_vip_course ? 1 : 0,
          order_type: 7,
          discount_id: val.discountId,
          shop_infos: JSON.stringify(val.checkedCourse),
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/course-detail.scss";
</style>
<style lang="scss">
.spell-qr {
  img {
    max-width: 100%;
    border-radius: 0 0 7px 7px;
    vertical-align: bottom;
  }
}
</style>
